import React from "react";
import {
  QuestionCircleFilled,
  CloseCircleFilled,
  SyncOutlined,
  CheckCircleFilled,
  ClockCircleFilled,
  ExclamationCircleFilled,
  StopFilled,
  InfoCircleOutlined,
  WarningOutlined,
  CloseCircleOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";
import { Avatar } from "antd";

export const migrationStatusIcons: { [key: string]: JSX.Element } = {
  draft: <QuestionCircleFilled key="draftIcon" style={{ color: "#08c" }} />,
  scheduled: (
    <ClockCircleFilled key="scheduledIcon" style={{ color: "#08c" }} />
  ),
  running: (
    <SyncOutlined key="runningIcon" style={{ color: "#52c41a" }} spin={true} />
  ),
  success: <CheckCircleFilled key="successIcon" style={{ color: "#52c41a" }} />,
  failed: <CloseCircleFilled key="failedIcon" style={{ color: "#f5222d" }} />,
  canceled: (
    <StopFilled key="canceledIcon" style={{ color: "rgba(0, 0, 0, 0.45)" }} />
  ),
  skipped: (
    <ExclamationCircleFilled key="skippedIcon" style={{ color: "#f5222d" }} />
  ),
  online: <CheckCircleFilled key="onlineIcon" style={{ color: "#52c41a" }} />,
  warning: (
    <ExclamationCircleFilled key="warningIcon" style={{ color: "#fadb14" }} />
  ),
  offline: <CloseCircleFilled key="offlineIcon" style={{ color: "#f5222d" }} />,
  unknown: (
    <QuestionCircleFilled key="unknownIcon" style={{ color: "#e8e8e8" }} />
  ),
};

function iconSizePx(size: number | "small" | "large" | "default"): number {
  if (size === "small") {
    return 16;
  } else if (size === "large" || size === "default") {
    return 32;
  } else {
    return size;
  }
}

export function agentStatus(agent): string {
  if (agent.lastCheckInAt == null) {
    return "Unknown";
  }
  const lastCheckin = new Date(Number(agent.lastCheckInAt)).getTime();
  const currentTime = new Date().getTime();
  const msSinceCheckin = currentTime - lastCheckin;
  const secondsSinceCheckin = msSinceCheckin / 1000;
  if (secondsSinceCheckin <= 60) {
    return "Online";
  } else if (secondsSinceCheckin <= 120) {
    return "Warning";
  } else {
    return "Offline";
  }
}

export function statusIcon(
  status: string = null,
  size: number | "small" | "large" | "default" = "default",
  type: "icon" | "avatar" = "icon"
): JSX.Element {
  if (!status) {
    status = "unknown";
  }
  const icon = migrationStatusIcons[status.toLowerCase()];
  if (type === "icon") {
    const style = Object.assign({}, icon.props.style);
    style["fontSize"] = iconSizePx(size);
    const sizedIcon = React.cloneElement(icon, { style: style });
    return sizedIcon;
  } else if (type === "avatar") {
    return (
      <Avatar
        style={{ background: "rgba(0, 0, 0, 0)" }}
        size={size}
        icon={icon}
      />
    );
  }
}

export const logStatusIcons: { [key: string]: JSX.Element } = {
  info: <InfoCircleOutlined key="infoIcon" style={{ color: "#52c41a" }} />,
  warn: <WarningOutlined key="warnIcon" style={{ color: "#fadb14" }} />,
  error: <CloseCircleOutlined key="errorIcon" style={{ color: "#f5222d" }} />,
  debug: (
    <QuestionCircleOutlined key="debugIcon" style={{ color: "#e8e8e8" }} />
  ),
};

export function logStatusIcon(level: string): JSX.Element {
  return logStatusIcons[level];
}
